export const LOGIN = 'LOGIN';
export const UPDATE_FIAT_OPTION = 'UPDATE_FIAT_OPTION';
export const LOGOUT = 'LOGOUT';